module.exports = __webpack_public_path__ + "18_hair_silver.c06a3390.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/18_hair_silver.png
// module id = kdpq
// module chunks = 0